import BossModal from '@components/Boss/BossModal';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState, useRef } from 'react';
import { DATA_GET_STORE } from '@utils/const';
import { getLabelFallback, handleHTTPError, loadScript } from '@utils/utils';
import { useForm, FormProvider } from 'react-hook-form';
import * as actions from '@redux-actions/';
import { fetchPhysicalStores, getBossStoreSelected, setBossShipping } from '@utils/services';
import ShopBag from '@images/svg-icons/shop.svg';
import PinGeolocate from '@images/svg-icons/pin-geolocate.svg';
import InputElementWithRef from '@components/InputElementWithRef';
import { usePlacesWidget } from 'react-google-autocomplete';
import { getMockedPhysicalStore } from '@utils/mockUtils';

const BossApp = props => {
  const openModalBoss = useSelector((state) => state.cart.openModalBoss);
  const radius = useSelector((state) => state.cart.radius);
  const isBossSelected = useSelector((state) => state.cart.isBossSelected);
  const latitude = useSelector((state) => state.cart.latitude);
  const longitude = useSelector((state) => state.cart.longitude);
  const cart = useSelector((state) => state.cart.cart);
  const selectedShippingMode = useSelector((state) => state.cart.selectedShippingMode);
  const errorBoss = useSelector((state) => state.cart.errorBoss);
  const formattedOrderItems = useSelector((state) => state.cart.formattedOrderItems);
  const config = useSelector((state) => state.cart.config);
  const methods = useForm();
  const dispatch = useDispatch();
  const [storeBossSelected, setStoreBossSelected] = useState(null);
  const [errorInput, setErrorInput] = useState(null);
  const [errorInputZipCode, setErrorInputZipCode] = useState(null);
  const [errorZipCodeNull, setErrorZipCodeNull] = useState(null);

  const onClose = () => {
    dispatch(actions.setOpenModalBoss(false));
    document.getElementById("content_wrapper_box").style.zIndex = '30';
    toggleLockPageScroll(false);
  };

  const toggleLockPageScroll = lock => {
    document.querySelectorAll('html,body').forEach(elem => {
      elem.style.overflow = lock ? 'hidden' : '';
      elem.style.position = lock ? 'fixed' : '';
      elem.style.height = lock ? '100%' : '';
      elem.style.width = lock ? '100%' : '';
    });
  };

  const openBoss = () => {
    //if (!!ref && !!ref.current && ref.current.value !== '') {
      if(config.mockRequests === false) {
        var Geocoder;
        Geocoder = new window.google.maps.Geocoder();
        Geocoder.geocode(
          { address: ref.current.value
          }, (response, status) => {
          if (status === 'OK' && response.length > 0) {
          
            let lng = response[0].geometry.location.lng();
            let lat = response[0].geometry.location.lat();

            let isPuertoRico = response[0].address_components.some(item => item.short_name === 'PR');
            
            if (!props.hasSmartGlasses || (props.hasSmartGlasses && !isPuertoRico)) {
              dispatch(actions.setLatitude(lat));
              dispatch(actions.setLongitude(lng));

              const dataWithOrderId = {
                ...DATA_GET_STORE,
                orderId: [cart.orderId],
              };
    
              fetchPhysicalStores(
                props.config.hostname,
                props.config.storeId,
                lat,
                lng,
                dataWithOrderId,
                radius
              )
                .then((res: any) => {
                  if (res && res.recordSetTotal !== '0') {
                    dispatch(actions.setOpenModalBoss(true));
                    document.getElementById("content_wrapper_box").style.zIndex = '999';
                    dispatch(actions.setPhysicalStores(res.PhysicalStore));
                    toggleLockPageScroll(true);
                    setErrorInput(false);
                  } else if (res && res.recordSetTotal === '0') {
                    setErrorInputZipCode(false);
                    setErrorInput(true);
                    window?.tealium_data2track.push({
                      id: 'Event',
                      Events_Error: '1',
                      Error_Code: 'No store found',
                      Error_Source: 'User',
                      Error_Details: 'No store found',
                      Error_Message: 'No store found. Please enter a zip code, city or state.'
                    })
                  }
                })
                .catch(err => {
                  window?.tealium_data2track.push({
                    id: 'Event',
                    Events_Error: '1',
                    Error_Code: 'Boss error',
                    Error_Source: 'Server',
                    Error_Details: err.data?.errors[0]?.errorMessage ? err.data.errors[0].errorMessage : '',
                    Error_Message: err.data?.errors[0]?.errorMessage ? err.data.errors[0].errorMessage : ''
                  });

                  console.error(
                    '>>> Error on get Stores for BOSS on Search => error status:',
                    err.status,
                    ', error: ',
                    err
                  );
                  handleHTTPError(dispatch, actions, err);
                });
            } else {
              setErrorInputZipCode(false);
              setErrorInput(true);
            }            
          } else {
            let isZipCode = /^[0-9]{5}$/.test(ref.current.value);
            setErrorInput(true);
            if (status === 'ZERO_RESULTS' && isZipCode) {
              setErrorInputZipCode(true);
              window?.tealium_data2track.push({
                id: 'Event',
                Events_Error: '1',
                Error_Code: 'No store found',
                Error_Source: 'User',
                Error_Details: 'No store found',
                Error_Message: 'No store found. Please enter a zip code, city or state.'
              })
            } else {
              if (ref.current.value == '' || !ref.current.value){
                setErrorZipCodeNull(true);
              }else{
                setErrorZipCodeNull(false);
              }              
              setErrorInputZipCode(false);
            }
          }
        });
      } else {
        getMockedPhysicalStore()
          .then(res => {
            dispatch(actions.setOpenModalBoss(true));
            document.getElementById("content_wrapper_box").style.zIndex = '999';
            dispatch(actions.setPhysicalStores(res.data.PhysicalStore));
            toggleLockPageScroll(true);
            setErrorInput(false);
          })
          .catch(err => {
            console.log('>>> Read mocked physical store error');
          })

      }
      
    /*} else {
      setErrorInput(true);
    }*/
  };

  const openBossGeolocate = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        let lng = position.coords.longitude.toString();
        let lat = position.coords.latitude.toString();

        dispatch(actions.setLatitude(lat));
        dispatch(actions.setLongitude(lng));

        const dataWithOrderId = {
          ...DATA_GET_STORE,
          orderId: [cart.orderId],
        };

        fetchPhysicalStores(
          props.config.hostname,
          props.config.storeId,
          lat,
          lng,
          dataWithOrderId,
          radius
        )
          .then((res: any) => {
            if (res && res.recordSetTotal !== '0') {
              dispatch(actions.setOpenModalBoss(true));
              document.getElementById("content_wrapper_box").style.zIndex = '999';
              dispatch(actions.setPhysicalStores(res.PhysicalStore));
              toggleLockPageScroll(true);
              setErrorInput(false);
            } else if (res && res.recordSetTotal === '0') {
              setErrorInputZipCode(false);
              setErrorInput(true);
              window?.tealium_data2track.push({
                id: 'Event',
                Events_Error: '1',
                Error_Code: 'No store found',
                Error_Source: 'User',
                Error_Details: 'No store found',
                Error_Message: 'No store found. Please enter a zip code, city or state.'
              })
            }
          })
          .catch(err => {
            window?.tealium_data2track.push({
              id: 'Event',
              Events_Error: '1',
              Error_Code: 'Boss error',
              Error_Source: 'Server',
              Error_Details: err.data?.errors[0]?.errorMessage ? err.data.errors[0].errorMessage : '',
              Error_Message: err.data?.errors[0]?.errorMessage ? err.data.errors[0].errorMessage : ''
            });

            console.error(
              '>>> Error on get Stores for BOSS on Geolocate => error status:',
              err.status,
              ', error: ',
              err
            );
            handleHTTPError(dispatch, actions, err);
          });
      });
    }
  };

  useEffect(() => {
    if(!!config && !!config.bossApp && !!config.bossApp.googleApiKey && config.bossApp.googleApiKey.length > 0) {
      if (typeof window.google === 'undefined') {
        //&& typeof(window.google.maps) === 'undefined' && typeof(window.google.maps.places) === 'undefined'
        loadScript(
          `https://maps.googleapis.com/maps/api/js?key=` + config.bossApp.googleApiKey + `&libraries=places`,
          () => {
            console.log('Import google');
          }
        );
      }
    }
  }, [config]);

  useEffect(() => {
    if (!!cart && !!cart.orderItem[0] && cart.orderItem[0].xitem_storeIdentifier) {
      getBossStoreSelected(
        props.config.mockRequests,
        props.config.hostname,
        props.config.storeId,
        cart.orderItem[0].xitem_storeIdentifier
      )
        .then((res: any) => {
          if (res) {
            setStoreBossSelected(res.PhysicalStore);
            dispatch(actions.setIsBossSelected(true));
          }
        })
        .catch(err => {
          console.error(
            '>>> Error on get Store information for BOSS => error status:',
            err.status,
            ', error: ',
            err
          );
          handleHTTPError(dispatch, actions, err);
        });
    }
  }, [cart]);

  useEffect(() => {
    if (!!latitude && !!longitude) {
      const dataWithOrderId = {
        ...DATA_GET_STORE,
        orderId: [cart.orderId],
      };
      fetchPhysicalStores(
        props.config.hostname,
        props.config.storeId,
        latitude,
        longitude,
        dataWithOrderId,
        radius
      )
        .then((res: any) => {
          if (res && res.recordSetTotal !== '0') {
            dispatch(actions.setPhysicalStores(res.PhysicalStore));
          }
        })
        .catch(err => {
          console.error(
            '>>> Error on get Stores for BOSS on change radius => error status:',
            err.status,
            ', error: ',
            err
          );
          handleHTTPError(dispatch, actions, err);
        });
    }
  }, [radius]);

  useEffect(() => {
    dispatch(actions.setErrorBoss(false));
  }, [selectedShippingMode]);

  function pad2(n) {
    return n < 10 ? '0' + n : n;
  }

  const deliverHere = store => {
    const date = new Date();
    const timestamp =
      date.getFullYear().toString() +
      pad2(date.getMonth() + 1) +
      pad2(date.getDate()) +
      pad2(date.getHours()) +
      pad2(date.getMinutes()) +
      pad2(date.getSeconds());
    setBossShipping(props.config.hostname, props.config.storeId, {
      catalog: props.config.catalogId,
      orderId: cart.orderId,
      bossStore: store.storeName,
      shipModeId: props.shipModeId,
      nickName: cart.buyerId + timestamp,
    })
      .then((res: any) => {
        onClose();
        dispatch(actions.setErrorBoss(false));
        dispatch(actions.getCart(props.config.mockRequests, props.config.hostname));
      })
      .catch(err => {
        console.error(
          '>>> Error on set Shipping for BOSS => error status:',
          err.status,
          ', error: ',
          err
        );
        handleHTTPError(dispatch, actions, err);
      });
  };

  const changeStore = () => {
    dispatch(actions.setIsBossSelected(false));
  };

  const { ref } = usePlacesWidget({
    apiKey: config.bossApp.googleApiKey,
    onPlaceSelected: place => console.log(place),
    options: {
      types: ["(regions)"],
      componentRestrictions: { country: ['us', 'pr'] },
    },
  });
  
  return(
    <>
      <div className="app-boss-selected store-selected" style={{display: isBossSelected ? 'block' : 'none'}}>
        <div className="store-selected-top">
          <div className="store-selected-top-left">
            <div className="store-selected-top-left-title">
              {!!storeBossSelected && !!storeBossSelected[0] && storeBossSelected[0].Description[0].displayStoreName.toLowerCase().replace('lenscrafters', 'LensCrafters')}
            </div>
            <div className="store-selected-top-left-address">
              {!!storeBossSelected && !!storeBossSelected[0] && storeBossSelected[0].addressLine[0].toLowerCase()}{' '}
              {!!storeBossSelected && !!storeBossSelected[0] && storeBossSelected[0].city.toLowerCase()}, {!!storeBossSelected && !!storeBossSelected[0] && storeBossSelected[0].stateOrProvinceName}
            </div>
          </div>
          <div className="store-selected-top-right">
            <button className="violet-button-negative" onClick={() => changeStore()} data-element-id="Summary_ChangeStore">
              {getLabelFallback('CHANGE_STORE_BUTTON_LABEL')}
            </button>
          </div>
        </div>
        <div className="store-selected-bottom">
          <div className="app-boss-text-container">{ getLabelFallback('BOSS_SELECTED_CLAIM_LABEL') }</div>
        </div>
      </div>

      <div className="app-boss container-fluid-boss" style={{display: !isBossSelected ? 'block' :  'none'}}>
        <div className="app-boss-title"> {getLabelFallback('BOSS_TITLE_LABEL')} </div>
        <FormProvider {...methods}>
          <form className="container-form" onSubmit={methods.handleSubmit(openBoss)}>
            <InputElementWithRef
              ref={ref}
              classes={'small' + (!!errorInput ? ' error-store-search' : '')}
              id="zip-code-boss"
              type="text"
              placeholder={getLabelFallback('COLLECT_TO_STORE_PLACEHOLDER')}
              required={true}
              maxLength={100}
            />
            <div className="pin-geolocate">
              <PinGeolocate onClick={() => openBossGeolocate()} />
            </div>            
            <button type="submit" className="violet-button" data-element-id="Delivery_CheckAvail">
              {getLabelFallback('COLLECT_TO_STORE_BUTTON_LABEL')}
            </button>
          </form>
        </FormProvider>
        {(!!errorInput || errorBoss) && (
          <div className="app-boss-text-error">
            {errorBoss
              ? getLabelFallback('BOSS_SEARCH_ERROR_CHECKOUT_LABEL')
              : errorZipCodeNull
              ? getLabelFallback('BOSS_SEARCH_ERROR_ZIP_CODE_LABEL')
              : getLabelFallback('BOSS_SEARCH_ERROR_LABEL')}
          </div>
        ) }
          <div className="app-boss-text">
            <div><ShopBag /></div>
            <div className="app-boss-text-container">{ getLabelFallback('BOSS_CLAIM_LABEL') }</div>
          </div>
        {openModalBoss && (
          <BossModal onClose={onClose} config={props.config} deliverHere={deliverHere} />
        )}
      </div>
    </>
  );
};

export default BossApp;
